import React from 'react'
import '../styles/Card.scss';

function Card(props) {
    return (

        <div className='card_widget'>
            <div className="card_foto_div">
                <a href={props.project.deploy}><img className='card_foto' alt='' src={props.project.img} /></a>
            </div>
                <div className='card_head'>
                    <span className={'card_type'}>{ props.project.type }</span><span className={'card_status'}>{ props.project.status }</span>
                </div>
                <div className='card_name'>
                    { props.project.name }
                </div>
                <div className='card_description'>
                    { props.project.description }
                </div>
                <div className='card_links'>
                    {props.project.deploy && <p><a href={props.project.deploy}><b>view the project</b></a></p>}
                    {props.project.git && <p><a href={props.project.git}><b>open in github</b></a></p>}
                </div>
                <div className='card_footer'>
                    <hr />
                    <div className='card_stack'>
                        <p><b>STACK:</b> {props.project.stack}</p>
                    </div>
                </div>
        </div>
    );
};

export default Card;